import React from 'react';
import Header from 'components/organisms/header';
import { useWebsocketRoom } from 'infrastructure/hooks/websockets/use-room';
import useUser from 'utils/useUser';

import CallDashboardLayout from './call-dashboard';

interface IProps {
  children: React.ReactNode;
  disableNavigation?: boolean;
}

const Layout: React.FC<IProps> = ({ children, disableNavigation }) => {
  const user = useUser();

  useWebsocketRoom('smsDashboard', {
    enabled: user.hasSmsRole,
  });

  return (
    <div className="app-wrapper">
      <CallDashboardLayout>
        <Header disableNavigation={disableNavigation} />
        <div className="patient-key-note-portal-container" />
        <div className="content">{children}</div>
      </CallDashboardLayout>
    </div>
  );
};

export default Layout;
